import { queryOptions } from '@tanstack/react-query'

import { fetchLogoUrl, fetchOrganization } from '#admin/features/organization/api.ts'

export const organizationQuery = () =>
  queryOptions({
    queryKey: ['identity', 'organization'],
    queryFn: ({ signal }) => fetchOrganization(signal),
  })

/** The presigned URL lives 300 s; refetched well inside that so a preview never 403s. */
export const logoQuery = (key: string) =>
  queryOptions({
    queryKey: ['identity', 'organization', 'logo', key],
    queryFn: ({ signal }) => fetchLogoUrl(key, signal),
    staleTime: 240_000,
  })
